export class AgeUtil {

  public static readonly MIN = 0;
  public static readonly MAX = 100;

}
